/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Upcoming1Inputs */

const id_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendatang`)
};

const ms_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const da_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const de_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehend`)
};

const en_us2_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const es_es2_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const es_mx2_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const fil_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparating`)
};

const fr_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const it_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimi`)
};

const hu_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő`)
};

const nl_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomend`)
};

const no_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const pl_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące`)
};

const pt_br2_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por vir`)
};

const pt_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const ro_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viitoare`)
};

const fi_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat`)
};

const sv_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande`)
};

const vi_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

const tr_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan`)
};

const cs_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející`)
};

const bg_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящи`)
};

const ru_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие`)
};

const uk_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майбутні`)
};

const ar_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة`)
};

const hi_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी`)
};

const th_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจะมา`)
};

const ja_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開`)
};

const zh_cn2_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将发布`)
};

const zh_hant1_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將發布`)
};

const ko_tags_sortby_upcoming1 = /** @type {(inputs: Tags_Sortby_Upcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Tags_Sortby_Upcoming1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_upcoming1 = /** @type {((inputs?: Tags_Sortby_Upcoming1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Upcoming1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_upcoming1(inputs)
	if (locale === "ms") return ms_tags_sortby_upcoming1(inputs)
	if (locale === "da") return da_tags_sortby_upcoming1(inputs)
	if (locale === "de") return de_tags_sortby_upcoming1(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_upcoming1(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_upcoming1(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_upcoming1(inputs)
	if (locale === "fil") return fil_tags_sortby_upcoming1(inputs)
	if (locale === "fr") return fr_tags_sortby_upcoming1(inputs)
	if (locale === "it") return it_tags_sortby_upcoming1(inputs)
	if (locale === "hu") return hu_tags_sortby_upcoming1(inputs)
	if (locale === "nl") return nl_tags_sortby_upcoming1(inputs)
	if (locale === "no") return no_tags_sortby_upcoming1(inputs)
	if (locale === "pl") return pl_tags_sortby_upcoming1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_upcoming1(inputs)
	if (locale === "pt") return pt_tags_sortby_upcoming1(inputs)
	if (locale === "ro") return ro_tags_sortby_upcoming1(inputs)
	if (locale === "fi") return fi_tags_sortby_upcoming1(inputs)
	if (locale === "sv") return sv_tags_sortby_upcoming1(inputs)
	if (locale === "vi") return vi_tags_sortby_upcoming1(inputs)
	if (locale === "tr") return tr_tags_sortby_upcoming1(inputs)
	if (locale === "cs") return cs_tags_sortby_upcoming1(inputs)
	if (locale === "bg") return bg_tags_sortby_upcoming1(inputs)
	if (locale === "ru") return ru_tags_sortby_upcoming1(inputs)
	if (locale === "uk") return uk_tags_sortby_upcoming1(inputs)
	if (locale === "ar") return ar_tags_sortby_upcoming1(inputs)
	if (locale === "hi") return hi_tags_sortby_upcoming1(inputs)
	if (locale === "th") return th_tags_sortby_upcoming1(inputs)
	if (locale === "ja") return ja_tags_sortby_upcoming1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_upcoming1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_upcoming1(inputs)
	return ko_tags_sortby_upcoming1(inputs)
});
export { tags_sortby_upcoming1 as "tags.sortBy.upcoming" }